import {
  FaCheckCircle,
  FaClipboard,
  FaInfinity,
  FaKeyboard,
  FaNewspaper,
  FaTasks,
  FaLock,
  FaHandsHelping,
  FaServer,
  FaMoneyCheck,
  FaDesktop,
  FaNetworkWired,
  FaUserAlt,
  FaHdd,
} from "@onemind-services-llc/react-icons-ng/fa";
import EVENG from "public/hosted-emulators/eve-ng.webp";

export const EVE_NG_CONSTANTS = {
  HERO_DESC: [
    "Skip the setup, dive straight into your project with CloudMyLab; and optimize resources for less money. Cloudmylab is a  EVE-NG Premium Cloud Partner and ready when you are, offering a flexible subscription service that adapts to your project's demands - freeing you to innovate, not administrate.",
    "Partner with us for streamlined network simulations, backed by our premium EVE-NG expertise.",
  ],
};

export const EVE_NG_FEATURES_LIST = [
  "Fast and Secure ",
  "The first Client-less Platform",
  "Automation and Integration options",
  "Multi-Vendor Environment ",
  "Built on Open Source",
  "HTML5 interface ",
  "Multi-user",
  "Click and Play Topology Designed",
  "Memory and CPU optimized",
];

export const EVE_NG_HOSTED_BACKED_SERVICES_LIST = [
  { icon: FaLock, content: "Fast and secure" },
  { icon: FaHandsHelping, content: "The first Client-less Platform" },
  { icon: FaServer, content: "Automation and Integration options" },
  { icon: FaMoneyCheck, content: "Multi-Vendor Environment" },
  { icon: FaDesktop, content: "Built on Open Source" },
  { icon: FaNetworkWired, content: "HTML5 interface" },
  { icon: FaUserAlt, content: "Multi-user" },
  { icon: FaHdd, content: "Memory and CPU optimized" },
  { icon: FaKeyboard, content: "Robust IT Infrastructure" },
  { icon: FaTasks, content: "Class Apart SLA of 99.1%" },
  { icon: FaInfinity, content: "24 X 7 Support" },
  { icon: FaNewspaper, content: "Free Trials" },
  { icon: FaClipboard, content: "Best Price Guaranteed" },
  { icon: FaCheckCircle, content: "Variable Length Subscription" },
];
export const LIST = [
  "Robust IT Infrastructure",
  "Class Apart SLA of 99.1%",
  "24 X 7 Support",
  "Free Trials",
  "Best Price Guaranteed",
  "Variable Length Subscription",
];

export const EVE_NG_REASON = [
  "EVE-NG is a powerful network emulation and virtualization software that allows you to create and run complex network topologies on a single computer or server. It provides a comprehensive environment for network engineers, administrators, and students to design, configure, and test various networking scenarios without the need for physical hardware.",
  "EVE-NG supports a wide range of network operating systems, including Cisco IOS, IOS-XE, IOS-XR, NX-OS, Juniper JunOS, Arista EOS, and many others. This flexibility enables you to build and experiment with heterogeneous network environments, simulating real-world network configurations.",
];

export const WhyEveNgList = [
  {
    title: "Zero Setup Time and Cloud-Hosted Accessibility",
    desc: "Launch your EVE-NG lab environment with just a few clicks through CloudMyLab's cloud-hosted platform. No need for complex installations or managing hardware - access powerful network emulation and virtualization capabilities from anywhere, anytime.",
  },
  {
    title: "Pre-Built Resources, Templates, and Real-World Scenarios",
    desc: "Jumpstart your network learning and experimentation with CloudMyLab's extensive library of pre-built resources for EVE-NG, including playbooks, modules, and real-life use case templates mirroring industry standards. Save time and gain practical, relevant experience.",
  },
  {
    title: "Rapid Deployment and Scalability",
    desc: "Get up and running with your EVE-NG lab in minutes with CloudMyLab's streamlined deployment process. Scale up your environment at any time to support business growth and evolving network requirements, whether managing a small network or a large enterprise system.",
  },
  {
    title: "​Cost-Effective Learning and Resource Optimization",
    desc: "Eliminate the need for expensive physical networking equipment and resources. CloudMyLab and EVE-NG provide a cost-effective solution optimized for efficient resource utilization, ensuring you get the most value for your investment.",
  },
  {
    title: "Multi-Vendor Environment and Automation Options",
    desc: "Create a multi-vendor environment with CloudMyLab and EVE-NG, simulating and testing various network devices and operating systems from different vendors. Streamline your workflows with CloudMyLab's automation and integration options.",
  },
  {
    title: "Robust Infrastructure, SLA, and Support",
    desc: "CloudMyLab is backed by a robust IT infrastructure, offering a class-apart SLA of 99.1% for high availability and reliability. Enjoy 24/7 support for prompt assistance whenever you need it.",
  },
];

export const EVE_NG_CLOUD_HOSTED_CARD = [
  {
    title: "EVE-NG community",
    subtitle: "For Individuals",
    content: [
      "This is a Single user open-source community edition for network Emulation and comes with several great features. This no-frills version is perfect for users with low budget.",
    ],
    image: EVENG,
    test: "eve-ng-comm",
  },
  {
    title: "EVE-NG Professional",
    subtitle: "For teams & Professionals",
    content: [
      "This is a multi-user Professional edition packed with extensive features, which makes it one of the top network emulation software in the market. CloudMyLab offers ready to use, EVE-NG Professional on Bare-Metal Servers and dedicated Cloud Instance. You can choose from a monthly or yearly subscription.",
    ],
    image: EVENG,
    test: "eve-ng-prof",
  },
  {
    title: "EVE-NG Corporate/Learning center.",
    subtitle: "For Organizations & Educational Centers",
    content: [
      "This is an enhanced EVE-NG Professional edition designed with role-based access control, designed to cater to Learning Centers, Universities and Enterprise customer. CloudMyLab offers ready to use, EVE-NG Professional on Bare-Metal Servers or Bare-Metal cluster with Yearly Licensing options.",
    ],
    image: EVENG,
    test: "eve-ng-corporate",
  },
];

export const EVE_NG_PRICING_TYPES = [
  {
    title: "​Cloud Hosted Solutions",
    desc: "Ideal for individuals or teams who require a flexible and scalable network emulator without the need for physical hardware. Save time and start immediately with our cloud-based offerings.",
  },

  {
    title: "​Baremetal Systems",
    desc: "Choose this for dedicated performance and control. Our baremetal solutions offer the raw power of physical hardware, tailored for those who demand the highest level of simulation fidelity.",
  },

  {
    title: "​Baremetal Clusters",
    desc: "Designed for enterprises and education centers that require a robust setup for extensive network emulation tasks. Get the collective power of multiple servers working together to simulate large, complex networks.",
  },
];

export const EVE_NG_COMPARE_TABLE_HEADERS = [
  "Features/Edition",
  "Community",
  "Professional",
  "Learning Center",
  "Description",
];

export const EVE_NG_FAQ = [
  {
    title: "What is EVE-NG, and how does it benefit network professionals?",
    desc1: [
      "EVE-NG (Emulated Virtual Environment - Next Generation) is a powerful network emulation software that allows network professionals to create virtual network topologies for testing, training, and proof-of-concept purposes. It provides a platform to run and interconnect virtual machines, such as routers, switches, and firewalls, from various vendors like Cisco, Juniper, Fortinet, and more.",
    ],
  },
  {
    title: "How can I access EVE-NG labs through CloudMyLab?",
    desc1: [
      "By leveraging CloudMyLab's hosted EVE-NG services, you can enjoy the benefits of a powerful network emulation platform without the hassle of setting up and maintaining the infrastructure yourself. This enables you to focus on your network simulations, learning, or testing, while CloudMyLab takes care of the underlying technical aspects.",
      "You can access EVE-NG labs through CloudMyLab by subscribing to one of the available plans, which offer different levels of resources to suit various needs. Once subscribed, you may connect to your dedicated EVE-NG instance through any standard web browser, enabling you to work on your network simulations from anywhere. From the EVE-NG interface, you can create new labs, import existing projects, or work on pre-configured templates provided by CloudMyLab.",
    ],
  },
  {
    title:
      "What types of devices and technologies can I simulate using EVE-NG on CloudMyLab?",
    desc1: [
      "With EVE-NG on CloudMyLab, you can interconnect devices and technologies to create realistic network topologies, test configurations, validate designs, and practice troubleshooting scenarios. The platform's flexibility allows you to experiment with different vendor technologies and gain hands-on experience in a safe, isolated environment.",
      "EVE-NG on CloudMyLab supports a wide array of devices and technologies, enabling users to simulate complex network environments. Some of the key devices and technologies you can work with include:",
    ],
    content: [
      {
        head: "Routers and Switches",
        data: [
          "Cisco IOS, IOS-XE, IOS-XR, and NX-OS. Juniper Junos, Arista EOS, Mikrotik RouterOS, VyOS",
        ],
      },
      {
        head: "Firewalls and Security Appliances:",
        data: [
          "Cisco ASA and FTD (Firepower Threat Defense), Palo Alto Networks PAN-OS, Fortinet FortiGate, pfSense, Check Point Gaia ",
        ],
      },
      { head: "Load Balancers: ", data: [" F5 BIG-IP LTM, HAProxy, Kemp LoadMaster"] },
      {
        head: "SD-WAN and WAN Optimization:",
        data: [
          "Cisco VIPTELA and IWAN, Riverbed SteelHead, Silver Peak Unity EdgeConnect",
        ],
      },
      {
        head: "Virtualization Platforms:",
        data: ["VMware ESXi, Microsoft Hyper-V, KVM (Kernel-based Virtual Machine)"],
      },
      { head: "Automation and Orchestration:", data: ["Ansible, Puppet, Chef "] },
      {
        head: "Linux and Windows Virtual Machines:",
        data: [
          "Ubuntu, CentOS, and other Linux distributions, Windows Server and Desktop versions",
        ],
      },
    ],
  },
  {
    title: "How does CloudMyLab ensure the security and reliability of EVE-NG labs?",
    desc1: [
      "CloudMyLab implements various measures to ensure the security and reliability of EVE-NG labs hosted on their platform:",
    ],
    content: [
      {
        head: "Secure Infrastructure:",
        data: [
          "CloudMyLab hosts EVE-NG instances in secure, ISO-certified data centers with strict physical access controls. The platform employs firewalls, intrusion detection, and prevention systems to protect against unauthorized access and cyber threats. Regular security audits and vulnerability assessments are conducted to identify and address potential risks.",
        ],
      },
      {
        head: "Data Isolation and Privacy:",
        data: [
          "Each user's EVE-NG instance is isolated from others, ensuring that lab configurations and data remain private and secure. CloudMyLab adheres to strict data privacy policies and complies with relevant regulations, such as GDPR.",
        ],
      },
      {
        head: "Backup and Disaster Recovery:",
        data: [
          "Regular backups of EVE-NG instances and user data are performed to protect against data loss. CloudMyLab maintains a robust disaster recovery plan to ensure business continuity and minimize downtime in the event of an incident",
        ],
      },
      {
        head: "Secure Access:",
        data: [
          "Users access their EVE-NG instances through secure protocols, such as HTTPS and SSH, to protect data in transit. Multi-factor authentication can be enabled to add an extra layer of security to user accounts.",
        ],
      },
      {
        head: "Monitoring and Support:",
        data: [
          "CloudMyLab continuously monitors the performance and availability of EVE-NG instances to proactively identify and resolve any issues. Users can access technical support through various channels, such as email, chat, or phone, to get assistance with their labs.",
        ],
      },
      {
        head: "Regular Updates and Maintenance:",
        data: [
          "CloudMyLab ensures that the underlying infrastructure and EVE-NG software are kept up-to-date with the latest security patches and updates. Regular maintenance is performed to optimize performance and address any potential vulnerabilities.",
        ],
      },
    ],
  },
];

export const EVE_NG_COMPARE_TABLE_DATA = [
  {
    feature: "License Price",
    community: "Free",
    professional: "$20/Month",
    learning_center: "$164/Year + $325/user",
    desc: "",
  },
  {
    feature: "User’s roles",
    community: "admin only",
    professional: "admin only",
    learning_center: "admin, user, editor",
    desc: "Restrictions of the EVE usage, WEB UI, per user based",
  },
  {
    feature: "Lock user per folder",
    community: false,
    professional: false,
    learning_center: true,
    desc: "User cannot see other EVE folders, only his own",
  },
  {
    feature: "Lock user edit rights",
    community: false,
    professional: false,
    learning_center: true,
    desc: "User cannot edit labs, images etc",
  },
  {
    feature: "Shared Lab Folder",
    community: false,
    professional: false,
    learning_center: true,
    desc: "Shared lab folder visible for all users",
  },
  {
    feature: "User’s account validity (1/4 Hour accuracy)",
    community: false,
    professional: false,
    learning_center: true,
    desc: "	Ability to set calendar validity for account, Date and time ( From -> To )",
  },
  {
    feature: "Lab Timer",
    community: false,
    professional: true,
    learning_center: true,
    desc: "Timer for Lab training",
  },
  {
    feature: "Running labs folder",
    community: false,
    professional: true,
    learning_center: true,
    desc: "	User can run more than one lab. Running labs will appear in special running labs folder. Per user based",
  },
  {
    feature: "Node limit per lab",
    community: "63",
    professional: "1024",
    learning_center: "1024",
    desc: "Limit of nodes to run per lab",
  },
  {
    feature: "TCP ports",
    community: "fixed 128 per POD",
    professional: "Dynamic 1-65000",
    learning_center: "Dynamic 1-65000",
    desc: "Automatic TCP port choose for telnet session",
  },
  {
    feature: "Local Wireshark capture",
    community: true,
    professional: false,
    learning_center: false,
    desc: "Local wrapper using ssh and root password to the EVE",
  },
  {
    feature: "Local Telnet client",
    community: true,
    professional: true,
    learning_center: true,
    desc: "Local wrapper using locally installed telnet client",
  },
  {
    feature: "Local VNC client",
    community: true,
    professional: true,
    learning_center: true,
    desc: "Local wrapper using locally installed vnc client",
  },
  {
    feature: "Wireshark integrated",
    community: false,
    professional: true,
    learning_center: true,
    desc: "Docker integrated wireshark",
  },
  {
    feature: "Docker container support",
    community: false,
    professional: true,
    learning_center: true,
    desc: "Docker container support",
  },
  {
    feature: "Running nodes interface connections (hot connections)",
    community: false,
    professional: true,
    learning_center: true,
    desc: "Hot/live nodes interface connection",
  },
  {
    feature: "NAT Cloud",
    community: false,
    professional: true,
    learning_center: true,
    desc: "Integrated NAT cloud, connect node to the internet. NAT to the EVE management interface DHCP 172.29.129.0/24, gateway .254",
  },
  {
    feature: "HTML console without Wireshark capture",
    community: true,
    professional: false,
    learning_center: false,
    desc: "HTML console",
  },
  {
    feature: "HTML console with Wireshark capture",
    community: false,
    professional: true,
    learning_center: true,
    desc: "HTML wireshark capture",
  },
  {
    feature: "HTML Desktop Console",
    community: false,
    professional: true,
    learning_center: true,
    desc: "Integrated Docker PC management",
  },
  {
    feature: "Multi startup configuration choose per lab",
    community: false,
    professional: true,
    learning_center: true,
    desc: "Option to create and boot lab from different startup configurations, multi startup config",
  },
  {
    feature: "Export/Import configs or config packs to local PC",
    community: false,
    professional: true,
    learning_center: true,
    desc: "Option import and export single config or config packs to the lab",
  },
  {
    feature: "EVE user Radius authentication",
    community: false,
    professional: true,
    learning_center: true,
    desc: "Multi Radius servers support",
  },
  {
    feature: "EVE user Active Directory authentication",
    community: false,
    professional: true,
    learning_center: true,
    desc: "Microsoft Active Directory support",
  },
  {
    feature: "Custom image template, cli based",
    community: false,
    professional: true,
    learning_center: true,
    desc: "Option create own image templates.",
  },
  {
    feature: "EVE Lab chat",
    community: false,
    professional: true,
    learning_center: true,
    desc: "Lab chat between EVE lab users.",
  },
  {
    feature: "Custom MAC address for Qemu nodes",
    community: false,
    professional: true,
    learning_center: true,
    desc: "Option to change first interface MAC address for qemu nodes",
  },
  {
    feature: "Shared Lab",
    community: false,
    professional: true,
    learning_center: true,
    desc: "Shared Lab folder, drop lab for others",
  },
  {
    feature: "Shared Project",
    community: false,
    professional: true,
    learning_center: true,
    desc: "Shared Lab one to many, Single Lab allows work a team with single lab.",
  },
  {
    feature: "Link Quality, Delay, packet loss, jitter",
    community: false,
    professional: true,
    learning_center: true,
    desc: "Feature allows apply link quality functions: packet loss, delay and rate",
  },
  {
    feature: "Link design feature",
    community: false,
    professional: true,
    learning_center: true,
    desc: "Option to change connection colour, style",
  },
  {
    feature: "Rich integrated text editor",
    community: false,
    professional: true,
    learning_center: true,
    desc: "Rich HTML text editor for text and objects management in the lab.",
  },
  {
    feature: "Advanced Lab design objects",
    community: false,
    professional: true,
    learning_center: true,
    desc: "Round square, lines, arrowed lines, style and colour",
  },
  {
    feature: "Admin user option to join in other user lab",
    community: false,
    professional: true,
    learning_center: true,
    desc: "Admin user can join to the other user lab in the parallel session",
  },
  {
    feature: "Admin user option to open parallel console session to other user node",
    community: false,
    professional: true,
    learning_center: true,
    desc: "Admin user can open parallel console session to other user node",
  },
  {
    feature: "Running labs and nodes management",
    community: false,
    professional: true,
    learning_center: true,
    desc: "	Admin can manage other user running labs and nodes. Join or stop labs or nodes.",
  },
  {
    feature: "EVE Cook Book",
    community: true,
    professional: true,
    learning_center: true,
    desc: "EVE Professional or Community Cook Book",
  },
  {
    feature: "Info about HDD/labs use per user, User infoweb GUI",
    community: false,
    professional: true,
    learning_center: true,
    desc: "Information about user HDD resource use",
  },
  {
    feature: "User quota (limit cpu/ram per user)",
    community: false,
    professional: false,
    learning_center: true,
    desc: "Limit cpu/ram per user. User profile EVE resource usage limitation.",
  },
  {
    feature: "Serial interface capture (IOL only)",
    community: false,
    professional: true,
    learning_center: true,
    desc: "HDLC/PPP/Frame Relay support for serial’s links",
  },
  {
    feature: "Link state and suspend / resume",
    community: false,
    professional: true,
    learning_center: true,
    desc: "Link state support for Qemu, IOL, Dockers",
  },
  {
    feature: "Dark Mode",
    community: true,
    professional: true,
    learning_center: true,
    desc: "Switch Lab view mode to Dark or Light mode",
  },
  {
    feature: "Lab Task management",
    community: false,
    professional: true,
    learning_center: true,
    desc: "Option to add offline pdf or online document into lab Task",
  },
  {
    feature: "EVE Cluster",
    community: false,
    professional: true,
    learning_center: true,
    desc: "Multi servers EVE system",
  },
];
